// import Swiper JS
import Swiper from 'swiper';
import { Pagination, EffectFade, Autoplay } from 'swiper/modules';

const initHeroSlider = () => {
    const swiperContainer = document.querySelector('.block-hero');

    if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
            // If we need pagination
            pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'bullets',
            renderBullet: (index, className) => {
                return `<span class="${className} block-hero__bullet"><span class="block-hero__bullet-progress"></span></span>`;
            },
            },
            slidesPerView: 1,
            modules: [Pagination, EffectFade, Autoplay],
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: {
                delay: swiperContainer.dataset.delay,
            },
            speed: 1000,
        });

        return swiper;
    }
    
};

initHeroSlider();
export default initHeroSlider;
